export default () => {
    return {
        vorgeschlageneDiagnose: 'not set yet',
        bestaetigteDiagnose: 'not set yet',
        empfehlung: 'not set yet',
        diagnoseConfirmed: false,
        patientIsPregnant: 'irrelevant',
        bestaetigteDiagnoseSelected:null,
        patientIsPregnantSelected:null,
    }
}